import { render, staticRenderFns } from "./CommonShowFolio.vue?vue&type=template&id=b637f678&scoped=true"
import script from "./CommonShowFolio.vue?vue&type=script&lang=js"
export * from "./CommonShowFolio.vue?vue&type=script&lang=js"
import style0 from "./CommonShowFolio.vue?vue&type=style&index=0&id=b637f678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b637f678",
  null
  
)

export default component.exports